
import "./index.scss";
import { useTranslation } from "react-i18next";
function DiverseScenarios({}) {
      const { t } = useTranslation();
      const language = localStorage.getItem("i18nextLng");
      const diverseScenariosContent = t("spaceOperations.space_part5", {
        returnObjects: true,
      });
  return (
    <div
      className="diverseScenarios"
    >
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div className="diverseScenarios_title">{diverseScenariosContent.title}</div>
          <span className="diverseScenarios_subhead">{diverseScenariosContent.subhead}</span>
        </div>
      </div>
      <div className="diverseScenarios_con">
        {diverseScenariosContent.space_partList.map((item0, index0) => {
          return (
            <div className="diverseScenarios_li" key={index0}>
              <div className="diverseScenarios_li_img" style={{background: `url(${item0.imgUrl}) no-repeat center center`}}>
                {/* <div className="kernalModule_li_icon"></div> */}
                {/* <img src={item0.imgUrl} alt="" style={{width:'100%'}}/> */}
              </div>
              <div className="diverseScenarios_li_content">
                <div
                    className="diverseScenarios_li_til"
                    style={
                    language === "zh"
                        ? { fontSize: "18px" }
                        : { fontSize: "16px" }
                    }
                >
                    {item0.itemTitle}
                </div>
                <div
                    className="diverseScenarios_li_con"
                    style={
                    language === "zh"
                        ? { fontSize: "16px" }
                        : { fontSize: "14px" }
                    }
                >
                    {item0.itemContent}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default DiverseScenarios;
